module.exports = __webpack_public_path__ + "static/media/Pomodoro.7b95bcce.png";